import { SerializableParam, selectorFamily, useRecoilValue } from "recoil";
import { DeductionService } from "services";
import { isAuthenticated, refreshState, useSetRefreshState } from "state";
import { AttachedDocument } from "types";
import { PaymentDetail } from "types/PaymentDetail"

type DocumentParams = {
    paymentDetail: PaymentDetail
} & SerializableParam;

export const deductionDocuments = selectorFamily<AttachedDocument[], DocumentParams>({
    key: 'deductionDocuments',
    get: ({ paymentDetail }) =>
        async ({ get }) => {
            get(refreshState(deductionDocuments({ paymentDetail }).key))
            if (get(isAuthenticated) && paymentDetail.accountId && paymentDetail?.vendorId) {
                const service = new DeductionService();
                const data = await service.getDeductionDocuments(paymentDetail.accountId, paymentDetail?.vendorId, paymentDetail);
                return data;
            }
            return [];
        }
});

export const useDeductionDocuments = (paymentDetail: PaymentDetail) => useRecoilValue(deductionDocuments({paymentDetail}));

export const useRefreshDeductionDocuments = (paymentDetail: PaymentDetail) => useSetRefreshState(deductionDocuments({paymentDetail}));